import PackAssignment from "./PackAssignment";

export default function Page() {
  return <PackAssignment />;
}